import Vue from "vue";
import VueRouter from 'vue-router'
import Home from '@/pages/index'
import Login from '@/pages/login'
import user from '@/pages/user'
import userHome from '@/components/userInfo/home'
import tutorials from '@/components/userInfo/Tutorials'
import downLoad from "@/components/userInfo/downLoad";
import money from "@/components/userInfo/money";
import answer from "@/pages/answer";
import product from "@/components/userInfo/product/product";
import customer from "@/pages/customer";
import share from "@/pages/share";
import shareLink from "@/components/userInfo/shareLink";
import proxyDetail from "@/components/userInfo/proxyDetail";
import withDrawal from "@/components/userInfo/withDrawal";
import Privacy from "@/pages/Privacy";
import useTutorial from "@/components/userInfo/product/useTutorial";
import upgradeTutorial from "@/components/userInfo/product/upgradeTutorial";
import superPenetration from "@/components/userInfo/superPenetration";
import editPass from "@/components/userInfo/editPass";
import {getToken} from "@/axios/token";
import kamil from "@/components/userInfo/kamil.vue";
import callbackAddress from "@/pages/CallbackAddress.vue";
import imageText from "@/components/userInfo/imageText.vue";

Vue.use(VueRouter);
let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace


// 重写push|replace
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => {
        }, () => {
        })
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => {
        }, () => {
        })
    }
}

//3.创建VueRouter的实例
const router = new VueRouter({
    mode: 'history',
    routes: [
        //首页
        {
            path: "/home",
            name: 'home',
            component: Home,
            meta:{
                title:'首页'
            }
        },
        //升级刷机路由器
        {
            path: 'upgradeTutorial',
            component: upgradeTutorial,
            name: 'upgradeTutorial',
            meta:{
                title:'升级路由器'
            }
        },
        //分享
        {
            path: '/share',
            name: 'share',
            component: share,
            meta:{
                title:'分享好友送好礼'
            }
        },
        //客服
        {
            path: '/customer',
            component: customer,
            name: 'customer',
            meta:{
                title:'联系客服'
            }
        },
        //常见问题
        {
            path: '/answer',
            name: 'answer',
            component: answer,
            meta:{
                title:'常见问题'
            }
        },
        //下载防断网客服端
        // {
        //     path: '/safetyNet',
        //     component: safetyNet,
        //     name: 'sagetyNet'
        // },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy,
            meta:{
                title:'隐私政策'
            }
        },
        //登录
        {
            path: "/login",
            name: 'login',
            component: Login,
            meta:{
                title:'登录注册'
            }
        },
        // 回调地址
        {
          path:"/callbackAddress",
          name:"callbackAddress",
          component:callbackAddress,
            meta:{
                title:'验证加载中......'
            }
        },
        //用户
        {
            path: "/user",
            name: 'user',
            redirect: '/user/userHome',
            component: user,
            children: [
                //用户主页
                {
                    path: 'userHome',
                    component: userHome,
                    name: 'userHome',
                    meta:{
                        title:'用户中心'
                    }
                },
                //修改密码
                {
                    path: 'editPass',
                    component: editPass,
                    name: 'editPass',
                    meta:{
                        title:'修改密码'
                    }
                },
                //教程
                {
                    path: 'tutorials',
                    component: tutorials,
                    name: 'tutorials',
                    meta:{
                        title:'使用教程'
                    }
                },
                //图文教程
                {
                    path: 'imageText',
                    component: imageText,
                    name: 'imageText',
                    meta:{
                        title:'图文教程'
                    }
                },
                //下载客户端
                {
                    path: 'downLoad',
                    component: downLoad,
                    name: 'downLoad',
                    meta:{
                        title:'客户端下载'
                    }
                },
                //分享链接
                {
                    path: 'shareLink',
                    name: 'shareLink',
                    component: shareLink,
                    meta:{
                        title:'分享链接'
                    }
                },
                //代理详情  
                {
                    path: 'proxyDetail/:userId',
                    name: 'proxyDetail',
                    component: proxyDetail,
                    meta:{
                        title:'代理用户详情'
                    }
                },
                //提现  withDrawal
                {
                    path: 'withDrawal',
                    name: 'withDrawal',
                    component: withDrawal,
                    meta:{
                        title:'申请提现'
                    }
                },
                //路由器
                {
                    path: 'product',
                    component: product,
                    name: 'product',
                    meta:{
                        title:'路由器购买'
                    }
                },
                {
                    path: 'useTutorial',
                    component: useTutorial,
                    name: 'useTutorial',
                    meta:{
                        title:'路由器使用说明'
                    }
                },
                //    超级穿透
                {
                    path: 'superPenetration',
                    component: superPenetration,
                    name: 'superPenetration',
                    meta:{
                        title:'超级穿透'
                    }
                },
                //充值
                {
                    path: 'money',
                    component: money,
                    name: 'money',
                    meta:{
                        title:'充值送好礼'
                    }
                },
                //卡密使用
                {
                    path:'kamil',
                    component:kamil,
                    name:'kamil',
                    meta:{
                        title:'使用卡密'
                    }
                }
            ]
        },
        // 重定向
        {
            path: '*',
            redirect: "/home"
        }
    ]
})

router.beforeEach((to, from, next) => {
    const token = getToken();

    // 路由发生变化修改页面title
    if (to.meta.title) {
        document.title = to.meta.title+'-火焰云加速器';
    }
    // 没有token,全都跳转到login
    if (!token) {
        if (to.path === "/login") {
            next();
            return;
        }

        if (to.path.indexOf("/user/") == -1  && to.path != "/user") {
            next();
            return;
        }

        next({
            path: '/login',
            query: {
                redirect: to.path
            }
        });
        return;
    }

    if (to.path === "/login") {
        if(to.query.t == "reg"){
            next();
            return;
        }

        next({path: 'user/userHome'});
        return;
    }

    next();
})
router.afterEach(() => {
    window, scrollTo(0, 0)
})

//5.导入路由实例
export default router